import {
  CREATE_TRIGGER_FAIL,
  CREATE_TRIGGER_START,
  //CREATE_TRIGGER_SUCCESS,
  //CREATE_HISTORY_SUCCESS,
  CREATE_HISTORY_START,
  CREATE_HISTORY_FAIL,
  TRIGGERS_DETAIL_SUCCESS,
  TRIGGERS_DETAIL_START,
  TRIGGERS_DETAIL_FAIL,
  //TRIGGERS_SLUG_SUCCESS,
  TRIGGERS_SLUG_FAIL,
  TRIGGERS_SLUG_START,
  HISTORY_DETAIL_SUCCESS,
  HISTORY_DETAIL_START,
  HISTORY_DETAIL_FAIL
} from './constants';

export const loggingReducer = (
  state = {
    history: {},
    triggers: [],
    fetching: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case CREATE_TRIGGER_START:
    case CREATE_HISTORY_START:
    case TRIGGERS_DETAIL_START:
    case HISTORY_DETAIL_START:
    case TRIGGERS_SLUG_START:
      return { ...state, fetching: true };
    case HISTORY_DETAIL_SUCCESS:
      return { ...state, history: { ...action.payload }, fetching: false }
    case TRIGGERS_DETAIL_SUCCESS:
      return { ...state, triggers: [ ...action.payload ], fetching: false }
    case CREATE_TRIGGER_FAIL:
    case CREATE_HISTORY_FAIL:
    case HISTORY_DETAIL_FAIL:
    case TRIGGERS_SLUG_FAIL:
    case TRIGGERS_DETAIL_FAIL:
      return { ...state, fetching: false, error: action.payload };
    default:
      return state;
  }
};
